<template>
	<svg class="LogoEbird" :class="classes" viewBox="0 0 157 57" role="img" :aria-labelledby="id">
		<title :id="id">eBird logo</title>
		<g fill="none">
			<path
				class="LogoEbird-e"
				fill="#4ca800"
				d="M33.15 46.93l-3.3-2-.25.44a14.22 14.22 0 0 1-4.25 5.15 9.37 9.37 0 0 1-5.17 1.4 10.71 10.71 0 0 1-5.08-1.13 9.41 9.41 0 0 1-3.44-3.09 14.56 14.56 0 0 1-2-4.78A26.59 26.59 0 0 1 9 37.25h23.14v-2.82a21 21 0 0 0-.82-6 13.68 13.68 0 0 0-2.51-4.84 12.19 12.19 0 0 0-4.61-3.43 16.71 16.71 0 0 0-6.75-1.25 15 15 0 0 0-6.93 1.59 15.88 15.88 0 0 0-5.16 4.2 19.35 19.35 0 0 0-3.25 6A21.77 21.77 0 0 0 1 37.58a25.7 25.7 0 0 0 1 7.33A17.71 17.71 0 0 0 5.18 51a15.06 15.06 0 0 0 5.4 4.17 17.79 17.79 0 0 0 7.59 1.53 15.35 15.35 0 0 0 8.74-2.56 18.43 18.43 0 0 0 6-6.84l.24-.37zM17.39 22.58a5.63 5.63 0 0 1 3.36.93A6.7 6.7 0 0 1 22.83 26a12.54 12.54 0 0 1 1 3.64 29.64 29.64 0 0 1 .33 3.68H9a13.63 13.63 0 0 1 2.54-7.81 7.08 7.08 0 0 1 5.85-2.93z"
			/>
			<path
				class="LogoEbird-bird"
				fill="#212121"
				d="M155.93 51.87l.5.01v3.23l-12.88.82-.84-.78v-2.63a15.28 15.28 0 0 1-4.13 2.89 13.18 13.18 0 0 1-5.78 1.36 13.72 13.72 0 0 1-6-1.38 15.06 15.06 0 0 1-5-3.86 19 19 0 0 1-3.4-6 23.1 23.1 0 0 1-1.25-7.74 20.45 20.45 0 0 1 1.34-7.36 19.57 19.57 0 0 1 3.7-6.1 16.45 16.45 0 0 1 5.45-3.91 17.06 17.06 0 0 1 11.5-.82 18.89 18.89 0 0 1 3.44 1.24V9.43a6.71 6.71 0 0 0-.46-2.53 3.68 3.68 0 0 0-1.21-1.65 6.5 6.5 0 0 0-2.48-.89 34 34 0 0 0-3.58-.44h-.45V.82l15-.82.84.82v47.29a3.86 3.86 0 0 0 .42 1.87c.3.53.725.976 1.24 1.3a3.92 3.92 0 0 0 1.72.45c.84.093 1.61.14 2.31.14zm-38.1-23.51A3.47 3.47 0 0 1 114.7 30a4.61 4.61 0 0 1-3.37-1.22 3.6 3.6 0 0 1-1.19-2.61 7.88 7.88 0 0 1 .13-1.51l.12-.66a8.52 8.52 0 0 0-3.1 1.28 11 11 0 0 0-3.56 3.55v20.19a3.36 3.36 0 0 0 .41 1.77 2.39 2.39 0 0 0 1.26 1 9 9 0 0 0 2.17.5c.91.12 1.72.25 2.4.25h.45v3.26H73.48v-3.26l2.13-.18A6 6 0 0 0 77 52.1a2.07 2.07 0 0 0 1.26-.9 3.53 3.53 0 0 0 .41-1.82V27.84a3.79 3.79 0 0 0-.46-1.84 4.12 4.12 0 0 0-1.29-1.45 6.26 6.26 0 0 0-1.78-.65 14.09 14.09 0 0 0-2.26-.36h-.45V20.3l13-.82.79.79V49a3.57 3.57 0 0 0 .42 1.78c.285.47.728.825 1.25 1a11.7 11.7 0 0 0 1.46.5 8.9 8.9 0 0 0 1.57.25h.33l2-.17a5.94 5.94 0 0 0 1.39-.26 2.06 2.06 0 0 0 1.21-.9 3.54 3.54 0 0 0 .41-1.82v-21.6a4.46 4.46 0 0 0-.46-1.95 3.81 3.81 0 0 0-1.28-1.51 4.36 4.36 0 0 0-1.42-.54 13.84 13.84 0 0 0-1.92-.26h-.45v-3.24l12.29-.82.79.79v4a15.86 15.86 0 0 1 4.35-3.63c3.78-2.09 7.14-2.04 9.14.05a5.87 5.87 0 0 1 1.53 4.23 6.38 6.38 0 0 1-1 3.46zM82 11.54A4.62 4.62 0 0 1 78.51 10a5.18 5.18 0 0 1-1.46-3.65 5.37 5.37 0 0 1 1.45-3.73A4.61 4.61 0 0 1 82 1a4.85 4.85 0 0 1 3.66 1.5A5 5 0 0 1 87.09 6a5.65 5.65 0 0 1-1.45 3.87A4.68 4.68 0 0 1 82 11.54zM67.94 31.52a12.81 12.81 0 0 1 3.79 4.05 11.64 11.64 0 0 1 1.52 6.09A12.3 12.3 0 0 1 71.66 48a13.65 13.65 0 0 1-4.16 4.39 18.74 18.74 0 0 1-5.5 2.55 23.12 23.12 0 0 1-6.27.83H31.46v-3.44h.44c.56-.05 1.38-.15 2.45-.3a9.13 9.13 0 0 0 2.21-.51 2.76 2.76 0 0 0 1.33-1.12 4 4 0 0 0 .4-1.91V12.3a4.76 4.76 0 0 0-.37-1.93 2.64 2.64 0 0 0-1.38-1.25 9.69 9.69 0 0 0-2.27-.78A17.1 17.1 0 0 0 32.14 8h-.45V4.58h23.64a25 25 0 0 1 5.26.54 15.85 15.85 0 0 1 4.84 1.94 10.71 10.71 0 0 1 3.59 3.52 10 10 0 0 1 1.42 5.43 11.69 11.69 0 0 1-1 4.93 10.91 10.91 0 0 1-2.82 3.73 16.22 16.22 0 0 1-3.85 2.46 21.58 21.58 0 0 1-3.11 1.15 30.88 30.88 0 0 1 3.34.85 17.29 17.29 0 0 1 4.94 2.39zm74.67-3.32a8.9 8.9 0 0 0-.83-1.73 8.4 8.4 0 0 0-1.5-1.84 8.62 8.62 0 0 0-2.27-1.38 7.76 7.76 0 0 0-3-.55 6.88 6.88 0 0 0-3.65 1 10 10 0 0 0-3 3 15.84 15.84 0 0 0-2 4.89 27.74 27.74 0 0 0-.75 6.67 23.39 23.39 0 0 0 .55 5.29 13.84 13.84 0 0 0 1.84 4.36 9.39 9.39 0 0 0 3 3 8 8 0 0 0 4.28 1.09 7.83 7.83 0 0 0 4.42-1.12 14.83 14.83 0 0 0 2.91-2.5V28.2zm-82.16-7.34a15.44 15.44 0 0 0 .5-4.15 8.59 8.59 0 0 0-2.13-6.18c-1.41-1.47-3.69-2.21-6.79-2.21-.747 0-1.69.017-2.83.05l-2.41.07v18.37h4a14.25 14.25 0 0 0 4.8-.72A7.31 7.31 0 0 0 58.73 24a8.34 8.34 0 0 0 1.72-3.14zm-13.66 9.92V48a3.24 3.24 0 0 0 1.58 3 9 9 0 0 0 4.77 1c3.36 0 5.95-.92 7.72-2.87 1.77-1.95 2.67-4.89 2.67-8.74a9.29 9.29 0 0 0-2.84-7c-1.89-1.81-4.66-2.73-8.22-2.73-1.507 0-2.777.017-3.81.05l-1.87.07z"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	data() {
		return {};
	},
	props: {
		/**
		 * unique ID automatically generated if not set
		 */
		id: {
			type: String,
			default: 'id-' + Math.random().toString(36).substr(2, 9),
		},
		/**
		 * for use on dark background
		 */
		reverse: {
			type: Boolean,
			default: false,
		},
		/**
		 * can be xs, sm, lg, xl, or responsive
		 */
		size: {
			type: String,
			default: null,
		},
	},
	computed: {
		classes() {
			return {
				'LogoEbird--reverse': this.reverse,
				'LogoEbird--xs': this.size === 'xs',
				'LogoEbird--sm': this.size === 'sm',
				'LogoEbird--lg': this.size === 'lg',
				'LogoEbird--xl': this.size === 'xl',
				'LogoEbird--responsive': this.size === 'responsive',
			};
		},
	},
};
</script>

<style lang="scss">
/* --------------------------------
	eBird logo
-------------------------------- */

/* Original dimensions of svg - used for calculating width from height */
$logo-ebird-orig-w: 157;
$logo-ebird-orig-h: 57;
/* Units to be used below */
$logo-ebird-units: rem;

/* Default logo style */
.LogoEbird {
	$logo-ebird-h-md: 2;
	$logo-ebird-w-md: calc-width-from-height($logo-ebird-orig-w, $logo-ebird-orig-h, $logo-ebird-h-md);
	height: #{$logo-ebird-h-md}#{$logo-ebird-units};
	width: #{$logo-ebird-w-md}#{$logo-ebird-units};
	max-width: 100%; /* Ensure svg will shrink with container */
	vertical-align: middle; /* Safety if width or height are overridden out of ratio */
	/* Style paths within svg */
	.LogoEbird-e {
		fill: #4ca800; // eBird green
	}
	.LogoEbird-bird {
		fill: #212121; // Lichen black
	}
}

/* ----------------
	Variants
---------------- */

/* Reverse variant for dark backgrounds */
.LogoEbird--reverse {
	.LogoEbird-e {
		fill: #6dcc1e;
	}
	.LogoEbird-bird {
		fill: #fff;
	}
}

/* Extra small (xs) variant */
.LogoEbird--xs {
	$logo-ebird-h-xs: 1;
	$logo-ebird-w-xs: calc-width-from-height($logo-ebird-orig-w, $logo-ebird-orig-h, $logo-ebird-h-xs);
	height: #{$logo-ebird-h-xs}#{$logo-ebird-units};
	width: #{$logo-ebird-w-xs}#{$logo-ebird-units};
}

/* Small (sm) variant */
.LogoEbird--sm {
	$logo-ebird-h-sm: 1.5;
	$logo-ebird-w-sm: calc-width-from-height($logo-ebird-orig-w, $logo-ebird-orig-h, $logo-ebird-h-sm);
	height: #{$logo-ebird-h-sm}#{$logo-ebird-units};
	width: #{$logo-ebird-w-sm}#{$logo-ebird-units};
}

/* Large (lg) variant */
.LogoEbird--lg {
	$logo-ebird-h-lg: 2.5;
	$logo-ebird-w-lg: calc-width-from-height($logo-ebird-orig-w, $logo-ebird-orig-h, $logo-ebird-h-lg);
	height: #{$logo-ebird-h-lg}#{$logo-ebird-units};
	width: #{$logo-ebird-w-lg}#{$logo-ebird-units};
}

/* Extra large (xl) variant */
.LogoEbird--xl {
	$logo-ebird-h-xl: 3;
	$logo-ebird-w-xl: calc-width-from-height($logo-ebird-orig-w, $logo-ebird-orig-h, $logo-ebird-h-xl);
	height: #{$logo-ebird-h-xl}#{$logo-ebird-units};
	width: #{$logo-ebird-w-xl}#{$logo-ebird-units};
}
</style>
